export const toOneBasedIndex = (index: number): number => index + 1;

export const toOneBasedIndexes = (indexes: number[]): number[] => indexes.map(toOneBasedIndex);
